import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// The rules live in the backend (CATEGORY_RULES) so the forms, bulk upload and API all follow the same ones.
// Fetched once per page load and shared by every form.
let rulesRequest = null;

export function useCategoryRules() {
  const [data, setData] = useState({ rules: {}, continents: [], country_continents: {} });

  useEffect(() => {
    if (!rulesRequest) {
      rulesRequest = axios.get(`${API_URL}/emission-factors/category-rules`).then(res => res.data);
    }
    rulesRequest.then(setData).catch(() => { rulesRequest = null; });
  }, []);

  return data;
}

// The Tag values allowed for a category / activity classification:
//   undefined  the category has no rule (Tag stays free text, as before)
//   null       the Tag field is disabled and must stay blank
//   [values]   the Tag is compulsory and must be one of the values
export function tagOptionsFor(rules, category, activityClassification) {
  const rule = rules[category];
  if (!rule) return undefined;
  if (Array.isArray(rule.tags)) return rule.tags;
  if (rule.tags) return rule.tags[activityClassification] ?? null;
  return null;
}

// The body of a zod superRefine: the same checks the backend makes, so mistakes show before submitting
export function checkCategoryRules(rules, data, ctx) {
  const rule = rules[data.category];
  if (!rule) return;

  if (data.activity_classification && !rule.activity_classifications.includes(data.activity_classification)) {
    ctx.addIssue({
      code: 'custom',
      path: ['activity_classification'],
      message: `Activity Classification for ${data.category} must be: ${rule.activity_classifications.join(', ')}`,
    });
  }

  const options = tagOptionsFor(rules, data.category, data.activity_classification);
  const tag = (data.tag || '').trim();
  if (options === null && tag) {
    ctx.addIssue({ code: 'custom', path: ['tag'], message: 'Tag is not used for this category' });
  } else if (Array.isArray(options) && !options.includes(tag)) {
    ctx.addIssue({ code: 'custom', path: ['tag'], message: `Tag is required: ${options.join(' / ')}` });
  }
}
